import React from 'react'

const Borderband = () => {
    return (
        <div className='bordermaincovr'>
            <div className='bdercontainer'>
                <div className="mainbrderbx">
                </div>
            </div>
        </div>
    )
}

export default Borderband
